import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DocumentMeta from "react-document-meta";
import LoginHeader from "../Common/LoginHeader";
import Footer from "../Common/Footer";
import { ProductName } from "../Common/ProductName";
import {
  useTransCurrenciesQuery,
  useTransGetDepositsListMutation,
} from "../../redux/TransactionApi";
import { Decimal_util } from "../../utils/Dec.util";

const CoinDepositFunction = () => {
  const meta = {
    title: `Deposit Transactions | ${ProductName} Exchange`,
    description: `Login on ${ProductName} Exchange now and start trading! Invite your friends to ${ProductName} Exchange.`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: `${ProductName} Exchange , Crypto Exchange, Buy Sell Crypto, Bitcoin Exchange India`,
      },
    },
  };

  const { data: currencies } = useTransCurrenciesQuery();
  const [getDepositsList] = useTransGetDepositsListMutation();

  const [transTitle, setTransTitle] = useState("Transaction Hash");
  const [currencyId, setCurrencyId] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    itemsPerPage: 50,
    totalItems: 0,
  });

  // Auto-select first currency
  useEffect(() => {
    if (!currencyId && currencies?.data?.length > 0) {
      setCurrencyId(currencies.data[0].id);
    }
  }, [currencies, currencyId]);

  // Fetch deposits whenever currencyId or page changes
  useEffect(() => {
    const fetchDeposits = async () => {
      if (!currencyId) return;

      const payload = {
        page: pagination.currentPage,
        limit: pagination.itemsPerPage,
        currency_id: currencyId,
      };

      const { data } = await getDepositsList(payload);
      if (data) {
        setTransactions(data.data || []);
        setPagination((prev) => ({
          ...prev,
          currentPage: data.pagination?.currentPage || 1,
          totalPages: data.pagination?.totalPages || 1,
          totalItems: data.pagination?.totalItems || 0,
        }));
      }
    };

    fetchDeposits();
  }, [currencyId, pagination.currentPage, getDepositsList]);

  // Currency tab list
  const renderCoinList = () =>
    currencies?.data?.map((item) => (
      <li
        key={item.id}
        onClick={() => {
          setTransTitle(item.symbol === "INR" ? "UTR/TID" : "Transaction Hash");
          setCurrencyId(item.id);
          setPagination((prev) => ({ ...prev, currentPage: 1 }));
        }}
      >
        <span className={currencyId === item.id ? "active" : ""}>
          {item.symbol}
        </span>
      </li>
    ));

  // Table rows (different fields than Spot)
  const renderTableRows = () =>
    transactions?.map((e, i) => {
      return (
        <tr key={e.id}>
          <td>{i + 1}</td>
          <td>{e.tx_type}</td>
          <td>{Decimal_util.fixedtillString(e.amount, 8)}</td>
          <td className="ip_width">{e.tx_hash}</td>
          <td>{e.symbol}</td>
          <td className="td_date">{e.created}</td>
          <td className="text-capital">{e.status}</td>
          <td>{e.payment_details?.reason ?? "-"}</td>
        </tr>
      );
    });

  // Pagination buttons
  const renderPagination = () => {
    if (pagination.totalPages <= 1) return null;

    return (
      <div className="pagination-controls mt-3">
        <button
          className="btn"
          disabled={pagination.currentPage === 1}
          style={{ opacity: pagination.currentPage === 1 ? 0.5 : 1 }}
          onClick={() =>
            setPagination((prev) => ({
              ...prev,
              currentPage: prev.currentPage - 1,
            }))
          }
        >
          Prev
        </button>
        <span className="m-3">
          Page {pagination.currentPage} of {pagination.totalPages} (
          {pagination.totalItems} records)
        </span>
        <button
          className="btn"
          disabled={pagination.currentPage === pagination.totalPages}
          style={{
            opacity: pagination.currentPage === pagination.totalPages ? 0.5 : 1,
          }}
          onClick={() =>
            setPagination((prev) => ({
              ...prev,
              currentPage: prev.currentPage + 1,
            }))
          }
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <DocumentMeta {...meta}>
      <div>
        <LoginHeader />
        <div className="bg_light">
          <div className="new_inpage">
            <div className="container container2">
              <div className="white_box">
                {/* Tabs */}
                <ul className="nav nav-tabs2 mb-3">
                  <li className="nav-item">
                    <Link to="/mainWalletTransactions"> Main Wallet </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/spotHistory"> Spot </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/coinDeposite" className="active">
                      Deposit Coin
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/coinFundRequest"> Withdrawal </Link>
                  </li>
                </ul>

                {/* Coin List */}
                <ul className="nav nav-tabs offer_beu spot">
                  {renderCoinList()}
                </ul>

                {/* Table */}
                <div className="tab-content">
                  <div className="tab-pane active" id="Balance">
                    <div className="rows">
                      <div className="wallet_box">
                        <div className="table-responsive">
                          <div className="scrool_wallet_box">
                            <table className="table table-striped mb-0">
                              <thead>
                                <tr>
                                  <th>Sr. No.</th>
                                  <th>Transaction Type</th>
                                  <th>Amount</th>
                                  <th className="ip_width">{transTitle}</th>
                                  <th>Currency Type</th>
                                  <th>Date & Time</th>
                                  <th>Status</th>
                                  <th>Reason</th>
                                </tr>
                              </thead>
                              <tbody>
                                {transactions.length > 0 ? (
                                  renderTableRows()
                                ) : (
                                  <tr>
                                    <td colSpan="7" className="text-center">
                                      No Transactions Found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {renderPagination()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </DocumentMeta>
  );
};

export default CoinDepositFunction;
